import { ReactNode, useState } from 'react'
import styled from '@emotion/styled/macro'
import { COLORS } from 'utils'
import { rem } from 'polished'
import ArrowIcon from 'assets/images/svg/arrow-bottom.svg'
import { Ellipsis } from 'components'

interface IAccordionProps {
  children: ReactNode
  title: ReactNode
  isInitialOpen?: boolean
}

const AccordionContainer = styled('div')`
  margin: 0;

  padding: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;

  border-radius: 8px;
  border: 1px solid ${COLORS.IRRADIANT_IRIS};
`

const AccordionTitle = styled('div')`
  display: flex;
  cursor: pointer;
  gap: ${rem(10)};
`

const AccordionContent = styled('div')`
  overflow: hidden;
  transition: max-height 1s ease-in-out;

  &[aria-expanded='true'] {
    max-height: 0px;
    transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
  }
`

const ToggleImage = styled('img')`
  width: 16px;
  height: 16px;
  align-self: center;
  margin-left: auto;
  transition: all 0.35s ease;

  &[aria-expanded='true'] {
    transform: rotateZ(180deg);
  }
`
export const Accordion = ({
  children,
  title,
  isInitialOpen = false,
}: IAccordionProps) => {
  const [isOpen, setIsOpen] = useState(isInitialOpen)

  return (
    <AccordionContainer>
      <AccordionTitle onClick={() => setIsOpen((prevValue) => !prevValue)}>
        <Ellipsis>{title}</Ellipsis>

        <ToggleImage
          src={ArrowIcon}
          aria-expanded={isOpen}
          alt="Toggle Accordion"
        />
      </AccordionTitle>
      <AccordionContent aria-expanded={!isOpen}>{children}</AccordionContent>
    </AccordionContainer>
  )
}
